module.exports = __webpack_public_path__ + "c_static/img/Share-QR-code_img_bg_default@2x.e733c39.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/邀请好友/Share-QR-code_img_bg_default@2x.png
// module id = 8BwD
// module chunks = 33